import SecureRequest from "../utils/securerequest";

export const fetchDocumentSignatures = async (documentId) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const url = `/v3/documents/${documentId}/document-signed`;

  return await Request.get(url);
};
